import { connect } from 'react-redux'
import { sagaActions as rootSagaActions } from 'store/sagas'
import AddDocumentSource from './AddDocumentSource'

export default connect(
  null,
  {
    requestAddDocumentSource: rootSagaActions.requestAddDocumentSource
  }
)(AddDocumentSource)

